import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';

import { CanDeactivateComponent } from '../models/can-deactivate-component.model';

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<CanDeactivateComponent>
{
  canDeactivate(
    component: CanDeactivateComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    return (
      nextState.url === '/welcome' ||
      (component.canDeactivate ? component.canDeactivate() : true)
    );
  }
}
